<template>
  <div>
    <v-row v-if="isNbnOrder">
      <v-col cols="12" class="py-0">
        <span class="px-0 py-2 kayako" @click="setData('nbnOrder')">{{
          params.data.nbnOrderId
        }}</span>
      </v-col>
    </v-row>
    <v-row v-if="isKayako">
      <v-col cols="12" class="py-0">
        <span
          v-if="params.shouldRedirect"
          class="px-0 py-2 kayako"
          @click="setData('kayako')"
        >
          {{ params.data.customerReference }}
        </span>
      </v-col>
    </v-row>
    <v-row v-if="!isNbnOrder">
      <v-col cols="2" class="pl-3 pr-5 py-0">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              medium
              v-bind="attrs"
              v-on="on"
              @click="setData('appointment')"
              class="mx-0"
              color="primary"
              :disabled="disableIcon(params.data, 'appointment')"
              >mdi-check-network</v-icon
            >
          </template>
          <span>Appointment</span>
        </v-tooltip>
      </v-col>
      <v-col cols="2" class="pl-3 pr-5 py-0">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              medium
              v-bind="attrs"
              v-on="on"
              @click="setData('order')"
              class="mx-0"
              color="primary"
              :disabled="
                params.data.orderType === '5G' &&
                !(
                  params.data.customerReference != '' ||
                  params.data.customerAuthReference != ''
                )
              "
              >mdi-format-list-bulleted-square</v-icon
            >
          </template>
          <span>View Order</span>
        </v-tooltip>
      </v-col>
      <v-col cols="2" class="pl-3 pr-0 py-0">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              medium
              v-bind="attrs"
              v-on="on"
              @click="setData('retrigger')"
              class="mx-0"
              color="primary"
              :disabled="
                params.data.orderType === '5G' ||
                params.data.radiusUsername === null ||
                params.data.radiusPassword === null
              "
              >mdi-restart</v-icon
            >
          </template>
          <span>Trigger Create Radius Account</span>
        </v-tooltip>
      </v-col>
      <v-col cols="2" class="pl-5 pr-0 py-0">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              medium
              v-bind="attrs"
              v-on="on"
              @click="setData('updateOnIseek')"
              class="mx-0"
              color="primary"
              >mdi-database-cog</v-icon
            >
          </template>
          <span>Iseek config sent manually</span>
        </v-tooltip>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  data: () => ({
    orderItem: null,
    isNbnOrder: false,
    isKayako: false,
  }),
  methods: {
    setData(type) {
      let data = this.params.data;
      data.type = type;
      this.params.clicked(data);
    },
    disableIcon(item, button) {
      let disable = true;
      if (item.orderType === "NBN") {
        switch (button) {
          case "addressQuery":
            disable = !item.locationId;
            break;
          case "sq":
            disable = !item.locationId;
            break;
          case "appointment":
            disable = !item.appointmentId || item.appointmentId === "NA";
            break;
        }
      } else {
        if (button === "addressQuery" || button === "sq") disable = false;
      }

      return disable;
    },
  },
  mounted() {
    this.isNbnOrder = this.params.colDef.field == "nbnOrderId";
    this.isKayako = this.params.colDef.field == "kayakoConversation";
  },
});
</script>

<style scoped>
.kayako {
  text-decoration: underline;
  color: #2f5578 !important;
  cursor: pointer;
  font-weight: bold;
}
</style>
